export const CONTACT_A_TECHNICIAN_OPTION = "Contact a technician"
export const VIEW_REPAIR_OPTIONS_OPTION = "View repair options"
export const CONTINUE_DIAGNOSING_OPTION = "Continue Diagnosing"

export const GRACEFUL_OFFRAMP_QUICK_RESPONSES = [
  VIEW_REPAIR_OPTIONS_OPTION,
  CONTINUE_DIAGNOSING_OPTION,
] as const
